import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loader = () => {
  return (
    <div 
      className="position-fixed w-100 h-100 d-flex justify-content-center align-items-center"
      style={{
        top: 0,
        left: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        backdropFilter: 'blur(8px)',
        zIndex: 9999
      }}
    >
      <div className="text-center">
        <Spinner 
          animation="border" 
          role="status" 
          variant="primary"
          style={{ width: '4rem', height: '4rem' }}
        >
          <span className="sr-only">Loading...</span>
        </Spinner>
      </div>
    </div>
  );
};

export default Loader; 